var ProductPdpShoppingCreditCampaigns = {
  SELECTOR: null,
  CONTAINER_SELECTOR: null,
  BEST_OFFER_SELECTOR: null,
  PRICE: null,
  init: function() {
    ProductPdpShoppingCreditCampaigns.SELECTOR = $('#product-shopping-credit-campaigns');
    ProductPdpShoppingCreditCampaigns.CONTAINER_SELECTOR = $('#product-shopping-credit-campaigns__container');
    ProductPdpShoppingCreditCampaigns.BEST_OFFER_SELECTOR = $('#product-shopping-credit-campaigns-best-offer');

    ProductPdpShoppingCreditCampaigns.PRICE = ProductPdpShoppingCreditCampaigns.SELECTOR.data('product-price');

    if(
      ProductPdpShoppingCreditCampaigns.SELECTOR.length > 0 && 
      ProductPdpShoppingCreditCampaigns.CONTAINER_SELECTOR.length > 0 && 
      ProductPdpShoppingCreditCampaigns.PRICE
    )
    {
      ProductPdpShoppingCreditCampaigns.SELECTOR.hide();
      ProductPdpShoppingCreditCampaigns.getCreditCampaigns();
    } else {
      console.warn('Campaigns not found.')
    }
  },
  getCreditCampaigns: function() {
    var apiBaseUrl = '';
  
    switch(window.CAMPAIGNS_ENV) {
      case 'production':
        apiBaseUrl = 'https://api.vivense.com/';
      break;
      case 'staging':
        apiBaseUrl = 'https://api-staging.vivense.com/';
      break;
      case 'sandbox':
        apiBaseUrl = 'https://api-sandbox.vivense.com/';
      break;
      case 'test':
      default:
        apiBaseUrl = 'https://api-test.vivense.com/';
      break;
    }

    $.ajax({
      type: 'GET',
      url: apiBaseUrl + 'availablepaymentcampaigns/' + ProductPdpShoppingCreditCampaigns.PRICE,
      success: function (response) {
          var data = response && response.items && Array.isArray(response.items) && response.items.length > 0 ? response.items[0] : null;
  
          if(data && data.creditCampaigns)
          {
            ProductPdpShoppingCreditCampaigns.setBestOffer(data.creditCampaigns.bestOffer);
            ProductPdpShoppingCreditCampaigns.setOffers(data.creditCampaigns.offers);

            ProductPdpShoppingCreditCampaigns.SELECTOR.show();
          }
      }
    });
  },
  setBestOffer: function(bestOffer) {
    $('#product-shopping-credit-campaign-first-text-term').html(bestOffer.term);

    ProductPdpShoppingCreditCampaigns.BEST_OFFER_SELECTOR.append(
      '<div class="product-shopping-credit-campaigns-best-offer-container">' + 
        '<div class="product-shopping-credit-campaigns-best-offer-title">' + 
          parseInt(bestOffer.amount).toLocaleString('tr-TR') + ' TL x ' + bestOffer.term + ' Ay Alışveriş Kredisi' + 
        '</div>' + 
        '<div class="product-shopping-credit-campaigns-best-offer-summary">' + 
          'Özel faiz oranlarıyla alışveriş kredini hemen kullan. ' + 
          '<a href="#product-shopping-credit-campaigns" id="product-shopping-credit-campaigns-best-offer__button" class="text-success">Detaylı Bilgi ></a>' +
        '</div>' +
      '</div>'
    );

    setTimeout(function() {
      $('#product-shopping-credit-campaigns-best-offer__button').click(function(e) {
        e.preventDefault();

        var location = $(this).attr("href");

        $('html,body').animate({scrollTop: $(location).offset().top - 100});

        $("#product-shopping-credit-campaigns").find(".panel-heading").addClass("open");
        $("#product-shopping-credit-campaigns").find(".panel-body").slideDown();
      });
    }, 1000);
  },
  setOffers: function(offers) {
    for(var i = 0; i < offers.length; i++)
    {
      var offer = offers[i];
      var offerHtml = ProductPdpShoppingCreditCampaigns.getOfferHtml(offer);


      ProductPdpShoppingCreditCampaigns.CONTAINER_SELECTOR.append(offerHtml);
    }
  },
  getOfferHtml: function(offer) {
    var offerRowsHtml = '';

    for(var i = 0; i < offer.bankOfferTerms.length; i++) {
      var bankOfferTerm = offer.bankOfferTerms[i];

      offerRowsHtml += 
        '<tr>' + 
          '<td>' + bankOfferTerm.term + ' Ay</td>' + 
          '<td>%' + bankOfferTerm.interestRate + '</td>' + 
          '<td>' + parseInt(bankOfferTerm.amount).toLocaleString('tr-TR') + ' TL</td>' + 
          '<td>' + parseInt(bankOfferTerm.totalAmount).toLocaleString('tr-TR') + ' TL</td>' + 
          '<td>%' + bankOfferTerm.annualInterestRate + '</td>' + 
        '</tr>';
    }

    return (
      '<div class="product-shopping-credit-campaign-offer">' + 
        '<div class="product-shopping-credit-campaign-offer__header">' +
            '<div class="product-shopping-credit-campaign-offer__header-title">' +
                '<img src="' + offer.bankIconUrl + '" class="product-shopping-credit-campaign-offer__header-logo"/>' +
                (!offer.isSupportNonCustomer ? '<div class="product-shopping-credit-campaign-offer__header-label">Banka Müşterilerine Özel</div>' : '') +
            '</div>' +
        '</div>' + 
        '<div class="table-responsive">' + 
            '<table class="table table-bordered table-striped table-condensed">' +
                '<thead>' + 
                  '<th>Vade</th>' + 
                  '<th>'+(offer.bankCode == 205 ? 'Kar Payı' : 'Faiz')+'</th>' +
                  '<th>Taksit</th>' + 
                  '<th>Toplam tutar</th>' + 
                  '<th>Yıllık Maliyet</th>' +
                '</thead>' + 
                '<tbody>' +
                offerRowsHtml + 
                '</tbody>' + 
            '</table>' + 
        '</div>' +
      '</div>'
    );
  }
};

$(document).ready(ProductPdpShoppingCreditCampaigns.init);